import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingSpinnerSize, SPINNER_SIZE_MAP } from './dtos/loading-spinner-size';

@Component({
  selector: 'aprova-loading-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent {
  @Input()
  public color: string = '#06929F';

  @Input()
  public size: LoadingSpinnerSize | number = 'md';

  @Input()
  public strokeWidth: number = 8;

  @Input()
  public overlay: boolean = false;

  @Input()
  public text: string = '';

  get sizeInPx(): number {
    if (typeof this.size === 'number') {
      return this.size;
    }
    return SPINNER_SIZE_MAP[this.size] || 40;
  }
}
